function updateFade(container, wrapper) {
  const scrollable = wrapper.scrollWidth > wrapper.clientWidth;

  if (!scrollable) {
    container.classList.remove('fade-right-visible', 'fade-left-visible');
    return;
  }

  const scrollLeft = wrapper.scrollLeft;
  const atEnd = scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 1;

  container.classList.toggle('has-right-overflow', !atEnd);
  container.classList.toggle('has-left-overflow', scrollLeft > 0);
}

function setupScrollFade(container) {
  const wrapper = container.querySelector('.pxg-club-table-scroll');
  if (!wrapper) return;
  updateFade(container, wrapper);
  wrapper.addEventListener('scroll', () => updateFade(container, wrapper));
  window.addEventListener('resize', () => updateFade(container, wrapper));
  window.addEventListener('load', () => updateFade(container, wrapper));
}
const containers = document.querySelectorAll('.pxg-club-table-scroll-container');
containers.forEach(setupScrollFade);